const TOKEN_KEY = "wedding_admin_token";
const TOKEN_EXP_KEY = "wedding_admin_token_exp";

export function setAuthToken(token, ttlSeconds) {
  localStorage.setItem(TOKEN_KEY, token);

  // ttl from backend looks like seconds; adjust if yours is ms
  const expiresAt = Date.now() + Number(ttlSeconds || 0) * 1000;
  localStorage.setItem(TOKEN_EXP_KEY, String(expiresAt));
}

export function getAuthToken() {
  const token = localStorage.getItem(TOKEN_KEY);
  const exp = Number(localStorage.getItem(TOKEN_EXP_KEY) || 0);

  if (!token) return null;
  if (exp && Date.now() > exp) {
    clearAuth();
    return null;
  }
  return token;
}

export function clearAuth() {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(TOKEN_EXP_KEY);
}

export function isLoggedIn() {
  return !!getAuthToken();
}
